// File: BaseIntegrationController.ts
import { BaseWebComponentController } from '../../framework/BaseWebComponentController';
import { NewIntegration } from '../saveIntegration/types';

export abstract class BaseIntegrationController extends BaseWebComponentController {
  abstract createIntegrationRecord(component: any): NewIntegration | null;
}
